module.exports = "/images/vendor/flag-icon-css/flags/4x3/cv.svg?f9922e019e929da267a67ee784bdde66";